import React, { useState } from 'react'
import DeactivateYourCompanyForm from '../UI/Form/DeactivateYourCompanyForm';
import SuccessAlert from '../UI/Alert/SuccessAlert';
import { useContentfulContext } from '../../contexts/ContentfulContext';

const DeactivateYourCompany = ( { setDeactivateCompany }) => {
    const { content } = useContentfulContext();

    const [deactivateSuccess, setDeactivateSuccess] = useState(false);
    return (
    <>
        <div className="w-full px-4 md:px-8 my-6">
            <div className="space-y-2 mb-6">
                <a href="#" onClick={(e) => {
                    e.preventDefault();
                    setDeactivateCompany(false);
                }} className="font-medium text-primary hover:underline flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" className="injected-svg fill-current mr-2">
                        <line x1="8.75" y1="12" x2="17.25" y2="12" stroke="white" strokeWidth="1.5" strokeLinecap="round"></line>
                        <path fillRule="evenodd" clipRule="evenodd" d="M11.5302 4.53033C11.8231 4.23744 11.8231 3.76256 11.5302 3.46967C11.2373 3.17678 10.7624 3.17678 10.4695 3.46967L3.17663 10.7626C2.49321 11.446 2.49321 12.554 3.17663 13.2374L10.4695 20.5303C10.7624 20.8232 11.2373 20.8232 11.5302 20.5303C11.8231 20.2374 11.8231 19.7626 11.5302 19.4697L4.81051 12.75H21.2499C21.6641 12.75 21.9999 12.4142 21.9999 12C21.9999 11.5858 21.6641 11.25 21.2499 11.25H4.81051L11.5302 4.53033Z"></path>
                    </svg>
                    { content.DEACTIVATE_YOUR_COMPANY.back_cta_text }
                </a>
            </div>
            <div className="flex flex-col space-y-2 mb-6">
                <h1 className="text-xl font-medium leading-tight tracking-tight text-gray-900 md:text-2xl">{ content.DEACTIVATE_YOUR_COMPANY.title }</h1>
                <p>{ content.DEACTIVATE_YOUR_COMPANY.description_1 }</p>
                <p>{ content.DEACTIVATE_YOUR_COMPANY.description_2 }</p>
            </div>
            <div className="space-y-7 w-full md:max-w-[520px] w-full">
                <DeactivateYourCompanyForm handleCancelClick={() => {
                    setDeactivateCompany(false);
                }} submitHandler={() => {
                    setDeactivateSuccess(true);
                }}/>
            </div>
        </div>
        { deactivateSuccess && <SuccessAlert disappearTime={content.DEACTIVATE_YOUR_COMPANY.success_alert.timeout}>{content.DEACTIVATE_YOUR_COMPANY.errors.FE138}</SuccessAlert> }
    </>
  )
}

export default DeactivateYourCompany;